<div class="s-full pos-rel fx-col fx-align-center fx-justify-around">
  <svg
    class="pos-abs"
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">

    <defs>
      <filter
        id="solid"
        primitiveUnits="objectBoundingBox">
        <feImage
          preserveAspectRatio="none"
          width="110%"
          height="110%"
          x="-5%"
          y="0%"
          [attr.xlink:href]="getFilterSolid()"/>
        <feComposite
          operator="over"
          in="SourceGraphic"/>
      </filter>
    </defs>

    <path
      *ngIf="!!fromSolarToGrid"
      stroke-width="1px"
      stroke="var(--grey-100)"
      [attr.d]="PATH_SOLAR_TO_GRID"/>
    <path
      *ngIf="!!fromSolarToHome"
      stroke-width="1px"
      stroke="var(--grey-100)"
      [attr.d]="PATH_SOLAR_TO_HOME"/>
    <path
      *ngIf="!!fromGridToHome"
      stroke-width="1px"
      stroke="var(--grey-100)"
      [attr.d]="PATH_GRID_TO_HOME"/>
    <path
      *ngIf="!!fromBatteryToHome"
      stroke-width="1px"
      stroke="var(--grey-100)"
      [attr.d]="PATH_BATTERY_TO_HOME"/>
    <path
      *ngIf="!!fromGridToBattery"
      stroke-width="1px"
      stroke="var(--grey-100)"
      [attr.d]="PATH_GRID_TO_BATTERY"/>
    <path
      *ngIf="!!fromSolarToBattery"
      stroke-width="1px"
      stroke="var(--grey-100)"
      [attr.d]="PATH_SOLAR_TO_BATTERY"/>

    <ng-container *ngFor="let _ of [].constructor(6); let i = index">
      <ng-container *ngFor="let _ of [].constructor(duration); let index = index">
        <ng-container *ngFor="let _ of [].constructor(2); let j = index">
          <!-- there are 2 circle, one for solid color(j === 0), one with blur color (j === 1)  -->
          <ng-container *ngTemplateOutlet="path; context: getPathConfig({
              color: getColor(i),
              size: j === 0 ? 2 : 3,
              blur: j === 0 ? false : true,
              delay: index,
              d: i === 0 ? PATH_SOLAR_TO_GRID : (i === 1)
                ? PATH_SOLAR_TO_HOME : (i === 2)
                ? PATH_GRID_TO_HOME : (i === 3)
                ? PATH_BATTERY_TO_HOME : (i === 4)
                ? PATH_GRID_TO_BATTERY : PATH_SOLAR_TO_BATTERY,
              active: i === 0 ? !!fromSolarToGrid : (i === 1)
                ? !!fromSolarToHome : (i === 2)
                ? !!fromGridToHome : (i === 3)
                ? !!fromBatteryToHome : (i === 4)
                ? !!fromGridToBattery : !!fromSolarToBattery,
              reverse: i === 0 ? (fromSolarToGrid || 0) < 0 : (i === 1)
                ? (fromSolarToHome || 0) < 0 : (i === 2)
                ? (fromGridToHome || 0) < 0 : (i === 3)
                ? (fromBatteryToHome || 0) < 0 : (i === 4)
                ? (fromGridToBattery || 0) < 0 : (fromSolarToBattery || 0) < 0
            })">
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template
      #path
      let-blur="blur"
      let-color="color"
      let-duration="duration"
      let-delay="delay"
      let-size="size"
      let-reverse="reverse"
      let-active="active"
      let-d="d">
      <path
        *ngIf="active"
        stroke-linecap="round"
        stroke-dasharray=".1 100%"
        fill="transparent"
        [attr.d]="d"
        [ngClass]="{
          'blur-1': blur === true
        }"
        [attr.stroke-width]="size"
        [style.animation-iteration-count]="'infinite'"
        [style.animation-timing-function]="'linear'"
        [style.animation-name]="'dash'"
        [style.animation-direction]="reverse ? 'reverse' : 'normal'"
        [style.animation-duration]="duration + 's'"
        [style.animation-delay]="delay + 's'"
        [attr.stroke]="color"/>
    </ng-template>

    <!-- fromSolarToGrid -->
    <ng-container *ngIf="showPowerFlow">
      <text
        *ngIf="!!fromSolarToGrid"
        class="text-bold"
        filter="url(#solid)"
        fill='var(--grey-400)'
        dominant-baseline="middle"
        text-anchor="middle"
        x="40"
        y="40"
        [style.font-size.px]="fontSize">
        {{ fromSolarToGrid | measures : valuePrecision : '' }}
      </text>

      <!-- fromSolarToHome -->
      <text
        *ngIf="!!fromSolarToHome"
        class="text-bold"
        filter="url(#solid)"
        fill='var(--grey-400)'
        dominant-baseline="middle"
        text-anchor="middle"
        x="60"
        y="40"
        [style.font-size.px]="fontSize">
        {{ fromSolarToHome | measures : valuePrecision : '' }}
      </text>

      <!-- fromGridToHome -->
      <text
        *ngIf="!!fromGridToHome"
        class="text-bold"
        filter="url(#solid)"
        fill='var(--grey-400)'
        dominant-baseline="middle"
        text-anchor="middle"
        x="45"
        y="50"
        [style.font-size.px]="fontSize">
        {{ fromGridToHome | measures : valuePrecision : '' }}
      </text>

      <!-- fromSolarToBattery -->
      <text
        *ngIf="!!fromSolarToBattery"
        class="text-bold"
        filter="url(#solid)"
        fill='var(--grey-400)'
        dominant-baseline="middle"
        text-anchor="middle"
        x="50"
        y="45"
        [style.font-size.px]="fontSize">
        {{ fromSolarToBattery | measures : valuePrecision : '' }}
      </text>

      <!-- fromGridToBattery -->
      <text
        *ngIf="!!fromGridToBattery"
        class="text-bold"
        filter="url(#solid)"
        fill='var(--grey-400)'
        dominant-baseline="middle"
        text-anchor="middle"
        x="40"
        y="60"
        [style.font-size.px]="fontSize">
        {{ fromGridToBattery | measures : valuePrecision : '' }}
      </text>

      <!-- fromBatteryToHome -->
      <text
        *ngIf="!!fromBatteryToHome"
        class="text-bold"
        filter="url(#solid)"
        fill='var(--grey-400)'
        dominant-baseline="middle"
        text-anchor="middle"
        x="60"
        y="60"
        [style.font-size.px]="fontSize">
        {{ fromBatteryToHome | measures : valuePrecision : '' }}
      </text>
    </ng-container>

    <!-- legend -->
    <text
      class="text-bold"
      fill='var(--grey-400)'
      dominant-baseline="middle"
      text-anchor="middle"
      x="10"
      y="10"
      [style.font-size.px]="fontSize">
      {{ unitLabel }}
    </text>

    <text
      class="text-bold text-style-italic"
      fill='black'
      dominant-baseline="middle"
      text-anchor="middle"
      x="22"
      y="10"
      [style.font-size.px]="fontSize">
      {{ unitSymbol }}
    </text>
  </svg>

  <div class="s-3p fx-center rounded z-index-1 pos-rel">
    <ng-content select="[solar]"></ng-content>
  </div>
  <div class="fx-row h-3p w-full fx-align-center fx-justify-between padding-inline-10p">
    <div class="w-3p fx-center h-full rounded z-index-1 pos-rel">
      <ng-content select="[grid]"></ng-content>
    </div>
    <div class="w-3p fx-center h-full rounded z-index-1 pos-rel">
      <ng-content select="[home]"></ng-content>
    </div>
  </div>
  <div class="s-3p fx-center rounded z-index-1 pos-rel">
    <ng-content select="[battery]"></ng-content>
  </div>
  <div class="z-index-1 pos-abs inset-b-2 inset-r-1">
    <ng-content select="[date]"></ng-content>
  </div>
</div>
